import CheckIcon from "@mui/icons-material/Check";
import { Button, Checkbox, FormControlLabel } from "@mui/material";
import { Spin } from "antd";
import React, { useContext, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import PsLabel from "../../components/PsLabel";
import PsContext from "../../context";
import { useDialog } from "../../context/DialogContext";
import { formToObject } from "../../utils";
import {
  _UPDATE_PARTNER_BANK,
  _UPDATE_PARTNER_SMSMAIL,
} from "../../models/agenciesModel";

const SmsEmail = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const { openDialog } = useDialog();

  const field = (fieldName) => props.dataSource[fieldName] || "";

  const [useDefaultSms, setUseDefaultSms] = useState(
    field("use_default_sms") === "1"
  );
  const [useDefaultEmail, setUseDefaultEmail] = useState(
    field("use_default_email") === "1"
  );
  const [senderId, setSenderId] = useState(field("sender_id"));
  const [dltTemplateId, setDltTemplateId] = useState(field("dlt_template_id"));
  const [signupMessage, setSignupMessage] = useState(field("signup_message"));
  const [emailSubject, setEmailSubject] = useState(field("email_subject"));
  const [emailMessage, setEmailMessage] = useState(field("email_message"));

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setLoader(true);
    _UPDATE_PARTNER_SMSMAIL(formToObject(form)).then((res) => {
      if (res.status === "1") {
        context.setAlertMsg(res.message || "Updated");
        if (props.onSuccess) props.onSuccess();
      } else {
        openDialog({
          title: "Error",
          message: res.message || "Error on Update",
        });
      }
      setLoader(false);
    });
  };

  const resetSmsFields = () => {
    setSenderId("");
    setDltTemplateId("");
    setSignupMessage("");
  };

  const resetEmailFields = () => {
    setEmailSubject("");
    setEmailMessage("");
  };

  return (
    <Spin spinning={loader}>
      <Form
        method="post"
        noValidate
        validated={validated}
        onSubmit={handleFormSubmit}
      >
        <input type="hidden" name="id" value={field("id")} />

        <Row className="mt-3">
          {/* SMS Section */}
          <Col md={6}>
            <Row className="mt-3">
              <Col md={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={useDefaultSms}
                      onChange={(e) => {
                        setUseDefaultSms(e.target.checked);
                        resetSmsFields(); // Reset SMS fields when the checkbox is toggled
                      }}
                      name="use_default_sms"
                    />
                  }
                  label="Use Default SMS Header"
                />
              </Col>
            </Row>

            {/* SMS Form Fields */}
            <Row className="mt-3">
              <Col md={5}>
                <PsLabel text="Sender ID" required />
              </Col>
              <Col md={7}>
                <Form.Control
                  type="text"
                  name="sender_id"
                  value={senderId} // Controlled value
                  placeholder="Enter Sender Id"
                  size="sm"
                  required
                  disabled={useDefaultSms}
                  onChange={(e) => setSenderId(e.target.value)}
                />
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md={5}>
                <PsLabel text="DLT TEMPLATE ID" required />
              </Col>
              <Col md={7}>
                <Form.Control
                  type="text"
                  name="dlt_template_id"
                  value={dltTemplateId} // Controlled value
                  placeholder="Enter DLT TEMPLATE ID"
                  size="sm"
                  required
                  disabled={useDefaultSms}
                  onChange={(e) => setDltTemplateId(e.target.value)}
                />
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md={5}>
                <PsLabel text="Signup Message" />
              </Col>
              <Col md={7}>
                <Form.Control
                  as="textarea"
                  name="signup_message"
                  value={signupMessage} // Controlled value
                  placeholder="Enter Signup Message"
                  size="sm"
                  disabled={useDefaultSms}
                  onChange={(e) => setSignupMessage(e.target.value)}
                />
              </Col>
            </Row>
          </Col>

          {/* Email Section */}
          <Col md={6}>
            <Row className="mt-3">
              <Col md={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={useDefaultEmail}
                      onChange={(e) => {
                        setUseDefaultEmail(e.target.checked);
                        resetEmailFields(); // Reset email fields when the checkbox is toggled
                      }}
                      name="use_default_email"
                    />
                  }
                  label="Use Default Email Header"
                />
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md={3}>
                <PsLabel text="Subject" />
              </Col>
              <Col md={9}>
                <Form.Control
                  type="text"
                  name="email_subject"
                  value={emailSubject} // Controlled value
                  placeholder="Enter Subject"
                  size="sm"
                  disabled={useDefaultEmail}
                  onChange={(e) => setEmailSubject(e.target.value)}
                />
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md={3}>
                <PsLabel text="Message" />
              </Col>
              <Col md={9}>
                <Form.Control
                  as="textarea"
                  name="email_message"
                  value={emailMessage} // Controlled value
                  placeholder="Enter Message"
                  size="sm"
                  disabled={useDefaultEmail}
                  onChange={(e) => setEmailMessage(e.target.value)}
                />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="mt-4">
          <Col>
            <Button type="submit" variant="contained" startIcon={<CheckIcon />}>
              Update
            </Button>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default SmsEmail;
